import { render } from "./TwilioTrackingForm.vue?vue&type=template&id=b7cbb9f2"
import script from "./TwilioTrackingForm.vue?vue&type=script&lang=js"
export * from "./TwilioTrackingForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cms.dealersgear.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__